import { Injectable } from '@angular/core';
import { TemplateApiService } from '../http/template-api.service';
import { Observable, map } from 'rxjs';
import { Template, TemplateDetails, TemplateSource, TemplateSourceEntity } from 'src/app/shared/models/template';
import AutoMapperService from './auto-mapper.service';

import {
    TemplateDetailsResponse,
    TemplateResponse,
    TemplateSourceEntityResponse,
    TemplateSourceResponse
} from 'src/app/shared/models/template-response';
import { TenantIngestionJobResponse } from '../../models/tenant-ingestion-job-response';
import { TenantIngestionJob } from 'src/app/shared/models/tenant-ingestion-job';

@Injectable({
    providedIn: 'root'
})
export class TemplateService {
    constructor(private service: TemplateApiService) {}

    getTemplates(): Observable<Template[]> {
        return this.service.getTemplates().pipe(
            map(response => {
                const templates =
                    response?.map(t => {
                        return this.mapToTemplate(t);
                    }) ?? [];
                return templates;
            })
        );
    }

    getTemplate(templateId: number): Observable<Template> {
        return this.service.getTemplate(templateId).pipe(
            map(response => {
                const data = this.mapToTemplate(response);
                return data;
            })
        );
    }

    private mapToTemplate(t: TemplateResponse) {
        const data = AutoMapperService.mapToApplicationModelSameCase<TemplateResponse, Template>(t);

        data.template = AutoMapperService.mapToApplicationModel<TemplateDetailsResponse, TemplateDetails>(t.template);
        data.template.tenantSource =
            t.template.tenant_source?.map(s => {
                const source = AutoMapperService.mapToApplicationModel<TemplateSourceResponse, TemplateSource>(s);
                source.entities =
                    s.entities?.map(e => {
                        const entities = AutoMapperService.mapToApplicationModel<
                            TemplateSourceEntityResponse,
                            TemplateSourceEntity
                        >(e);

                        entities.loads = e.loads.map(l =>
                            AutoMapperService.mapToApplicationModel<TenantIngestionJobResponse, TenantIngestionJob>(l)
                        );

                        return entities;
                    }) ?? [];
                return source;
            }) ?? [];

        return data;
    }
}
